import { gql } from "@apollo/client";

const CurrentUser = gql`
  query CurrentUser {
    currentUser {
      appId
      firstName
      lastName
      email
      changePassword
      isAdmin
      isExternal
      isActive
    }
  }
`;

const hash = "8c44634ae8e28645669d0d4d68fa0e9e5618fba2a42043fa535bc76a86a99328";

export { CurrentUser, hash };
